module.exports = __webpack_public_path__ + "assets/fe55eccb4a8a5e58b8770d0d5963fe55.png";